"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _ExperimentContext = require("../context/ExperimentContext");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A hook that returns the loading state of the experiments as well as a value object
 * containing the following shape:
 * { [dimensionName]: variantName }
 * @param {String} experimentName The name of the experiment to get from state.
 * @param {String} [dimension] The name of the dimension to get associated to the experiment.
 * @returns {{isLoading: boolean, value: (undefined|{dimensions: Object.<string, string>})}}
 * An object representing the loading state of the experiments and an object value that
 * contains dimension names as the keys and variants as the values.
 * @throws Will throw an error when experimentName is not defined.
 */
var useExperimentDecision = function useExperimentDecision(experimentName) {
  var dimension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!experimentName) {
    throw new Error('Please ensure all experiments have a given experimentName');
  }

  var _useExperimentContext = (0, _ExperimentContext.useExperimentContext)(),
      _useExperimentContext2 = _useExperimentContext.selectors,
      getExperiment = _useExperimentContext2.getExperiment,
      getExperimentVariant = _useExperimentContext2.getExperimentVariant,
      getState = _useExperimentContext2.getState;

  var _getState = getState(),
      isLoading = _getState.isLoading;

  var experiment = getExperiment(experimentName);

  var _getExperimentVariant = getExperimentVariant(experimentName, dimension),
      fetchedVariant = _getExperimentVariant.variant,
      fetchedDimension = _getExperimentVariant.dimension;

  var experimentValue = (0, _react.useMemo)(function () {
    if (!experiment) {
      return undefined;
    }

    if (dimension) {
      return {
        dimensions: _defineProperty({}, fetchedDimension, fetchedVariant)
      };
    }

    return {
      dimensions: experiment.dimensions || {}
    };
  }, [dimension, experiment, fetchedDimension, fetchedVariant]);
  return {
    isLoading: isLoading,
    value: experimentValue
  };
};

var _default = useExperimentDecision;
exports.default = _default;